import {GetterTree} from "vuex";
import {ISlide} from "../models/slide";
import {WidgetState} from "../models/store-state";

export default <GetterTree<WidgetState, WidgetState>>{
    sliderComponent(state): string {
        return `${state.config.type}SliderComponent`
    },
    slides(state): Array<ISlide> {
        return state.config.slides
    },
    validIndex: (state) => (index: number) => {
        return (index + state.config.slides.length) % state.config.slides.length
    },
    multipleSlides(state, getters): Array<ISlide> {
        if (!getters.showNavigation) {
            return state.config.slides
        }

        let slides: Array<ISlide> = []

        for (let i = -1; i <= state.slidesPerView; i++) {
            let index = getters.validIndex(state.currentIndex + i)
            slides.push(state.config.slides[index])
        }

        return slides
    },
    singleSlide(state): ISlide {
        return state.config.slides[state.currentIndex]
    },
    shouldShowLink: () => (slide: ISlide) => {
        return Boolean(slide?.link?.trim())
    },
    shouldShowContent: () => (slide: ISlide) => {
        let containsLinkText: boolean = Boolean(slide?.linkText?.trim())
        let containsParagraphs: boolean = slide?.content?.paragraphs?.length > 0
        return containsLinkText && containsParagraphs
    },
    showNavigation(state): boolean {
        return state.config.slides.length > state.slidesPerView
    },
    assetComponent: () => (slide: ISlide) => {
        return slide.video ? 'VideoComponent' : 'ImageComponent'
    },
    assetContent: () => (slide: ISlide) => {
        return slide.video ?? slide.image
    },
    imageFallback(state): string {
        return state.config.imageFallback;
    }
}